/**
 * Client automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {ClientAbstract, CredentialsInterface, TokenStoreInterface, HttpRequest} from "sdkgen-client"
import {Anonymous} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {AuthorizationTag} from "./AuthorizationTag";
import {BackendTag} from "./BackendTag";
import {ConsumerTag} from "./ConsumerTag";
import {SystemTag} from "./SystemTag";

export class Client extends ClientAbstract {
    public authorization(): AuthorizationTag
    {
        return new AuthorizationTag(
            this.httpClient,
            this.parser
        );
    }

    public backend(): BackendTag
    {
        return new BackendTag(
            this.httpClient,
            this.parser
        );
    }

    public consumer(): ConsumerTag
    {
        return new ConsumerTag(
            this.httpClient,
            this.parser
        );
    }

    public system(): SystemTag
    {
        return new SystemTag(
            this.httpClient,
            this.parser
        );
    }




    public static buildAnonymous(baseUrl: string): Client
    {
        return new Client(baseUrl, new Anonymous());
    }
}
